import type { Profile, GreetSendType, Transcript } from '~/types/models';
import type { Reply } from '~/types/models/reply';
import type { MessageTemplateShare } from '~/types/models/index';
import { Assignee } from '../api/nextgen';

interface Greet {
  id: string;
  slug: string;
  video_url: string;
  thumb_url: string;
  message: string;
  transcript?: Transcript;
  created_at: string;
}

export type Recording = {
  id: string;
  message: string;
  thumb_url: string;
  video_url: string;
  slug: string;
  transcript?: Transcript;
  upload_source: string;
};

interface Lang {
  commentPlaceholder: string;
  post: string;
  posting: string;
  replyByVideo: string;
  thanks: string;
}

export interface GreetMetadata {
  source_created_by?: Partial<string>;
  delivery_type?: Partial<string>;
  email_preview?: Partial<string>;
  send_type?: Partial<GreetSendType>;
}

export enum LandingPageType {
  Greet = 'greet',
  Recording = 'recording',
}

export enum LandingPageIntent {
  ReplyByVideo = 'reply_by_video',
}

export type RootState = {
  model: Recording | Greet;
  features: Record<string, string | number | boolean | null>;
  messageTemplate: MessageTemplateShare;
  assignee: Assignee;
  type: LandingPageType;
  greetType: string;
  intent?: LandingPageIntent;
} & Partial<GreetShareState>;

export interface GreetShareState {
  profile: Partial<Profile>;
  reactionCount: number;
  lang: Lang;
  isRecipient: boolean;
  url: string;
  tracked: boolean;
  replyByVideo: boolean;
  metadata: GreetMetadata;
}

export interface CommentState {
  comments: Reply[];
  creating: boolean;
  errorMessage: string | null;
  focused: boolean;
  value: string;
}

export interface VideoState {
  playing?: boolean;
  progress?: number;
  error?: string;
}

export interface AnalyticsTracking {
  shareModalClicked: () => Promise<void>;
  videoWatched: () => Promise<void>;
  videoEmbedPlayed: () => Promise<void>;
  ctaClicked: () => Promise<void> | undefined;
}

export type ReduxState = {
  root: RootState;
  comments: CommentState;
  video: VideoState;
  tracking: AnalyticsTracking;
};

export type StateFunction = () => ReduxState;
